<template>
<MyApp/>
</template>

<script>
import MyApp from "@/components/MyApp";

var DOMAIN = 'https://harmony.localhost';

// console.log(window.location.hostname)
if (window.location.hostname != '192.168.0.107' && window.location.hostname != 'localhost') {
  DOMAIN = '';
}

export default {
  name: 'App',
  components: {MyApp},
  provide() {
    return {
      URL_PAYMENT: DOMAIN + '/v1/api/payment',
      URL_GETWEEK: DOMAIN + '/v1/api/getweek',
      URL_BOOKING: DOMAIN + '/v1/api/booking',
      URL_CANCEL: DOMAIN + '/v1/api/cancel',
      URL_SENDMODE: DOMAIN + '/v1/api/schedulemode',
      URL_SET_MEMORY_BOOKINGS: DOMAIN + '/v1/api/setmemorybookings'
    }
  }
}
</script>
<style>
.modal-container {
  background: #3e3e3e6e !important;
  z-index: 3000;
}

.h-card {

  background: #fff;
  border-radius: 10px;
  overflow: hidden;
}

.h-card .card-header {
  display: flex;
  background: #ffe9a580;
  border-bottom: 1px solid #cccccc8f;
  padding: 0.5em;
  justify-content: space-between;
}

.h-card .card-header .modal-title {
  font-size: 1em;
  /*text-shadow: 0px 1px 0px #fff;*/
}

.h-card .card-footer {
  display: flex;
  background: #ebebeb73;
  border-bottom: 1px solid #cccccc8f;
  padding: 0.5em 0.8em;
  justify-content: flex-end;
}

.h-card .card-footer .ok-btn,
.h-card .card-footer .close-btn {
  padding: 0.4em 1em;
  background: #e7e7e7;
  font-size: .8em;
  line-height: 1.75em;
  border-radius: 1.3em;
  border: 1px solid #fff;
  box-shadow: inset 0px 0px 0px 1px #34343417;
  /*text-shadow: 0px 1px 0px #fff;*/
}

.h-card .card-footer .ok-btn {
  background: #ffdfaa;
}

.h-card .card-body {
  padding: 0.8em 0.8em;
}
</style>